import FileSaver from 'file-saver';

/**
 * Downloads a file locally
 * Requires `file-saver` package
 * @param file
 * @param filename
 */
export const downloadFiles = async (file: Blob | Promise<Blob>, filename: string) => {
  FileSaver.saveAs(await file, `${filename.replace(/[^a-zÀ-úA-Z0-9._]/gi, '')}`);
};
